import styled from 'styled-components';

export const wrapperInput = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ tamanho }) => (tamanho || '')};

  .ant-input:focus{
    border: 1px solid #24A95D;
  }

  .ant-input:hover{
    border: 1px solid #24A95D;
  }

  label {
    color: #000;
    font-weight: bold;
    font-size: 14px;

  }
  .ant-form-item-required::before{
    display:none !important;
  }
  .ant-form-item-explain.ant-form-item-explain-error {
    color: #ff4d4f;
    position: relative;
    margin-top: -32px;
}

`;
export const DivForm = styled.div`
  border: 1px solid white;
  width: 768px;
  min-height: 448px;
  padding: 52px 64px 32px 64px;
  border-radius: 2px;
  background:#fff;
`;

export const Separator = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  gap: 32px;
`;

export const SeparatorButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin:0;
  gap: 32px;
`;

export const ButtonSave = styled.button`
  width: 192px;
  height: 45px;
  color: #fff;
  margin:0;
  border: 1px solid #24a95d;
  background: #24a95d;
  outline: none;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background: #24a95d;
    transform: scale(1.02);
  }
`;

export const ButtonCancel = styled.button`
  cursor: pointer;
  width: 192px;
  margin:0;
  height: 45px;
  color: #24a95d;
  border: 1px solid #24a95d;
  background: transparent;
  font-weight: bold;
  &:hover {
    background: transparent;
    transform: scale(1.02);
  }
`;
